<script setup lang="ts">
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import DatePicker from '@/components/DailyReportEdit/Combine/DatePicker.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue', 'search']);

const props = defineProps<{
  deliveryPlan: getDeliveryPlanVehicleInformation
  modelValue: {
    operation_office_id: number,
    driver_id: string,
    account_id: number,
    daterange: Date[],
    selectDateType: string,
  }
  isSearching: boolean
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});
</script>
<template>
  <div class="w-100">
    <div class="w-100 d-flex">
      <h4 class="mx-auto">
        {{ i18n.global.t('pages.dailyReports.combineForm.driver') }}: {{ props.deliveryPlan.driver.full_name }}
      </h4>
    </div>
    <DatePicker
      v-model="modelValue.daterange"
    />
    <div class="w-75 d-flex mx-auto justify-space-between">
      <div class="p-1">
        <v-radio-group
          v-model="modelValue.selectDateType"
          class="radio-group-row"
        >
          <v-radio
            value="leaving"
            :label="i18n.global.t('pages.dailyReports.leavingWarehouseDate')"
            color="blue"
            class="mr-2"
          />
          <v-radio
            value="returning"
            :label="i18n.global.t('pages.dailyReports.returningWarehouseDate')"
            color="blue"
          />
        </v-radio-group>
      </div>
      <v-btn
        class="ma-2 exec-btn"
        :loading="props.isSearching"
        @click="emits('search')"
      >
        {{ i18n.global.t('pages.common.button.search') }}
      </v-btn>
    </div>
  </div>
</template>
